'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    ', ';\n    width: 100%;\n'], ['\n    display: flex;\n    flex-direction: column;\n    ', ';\n    width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: fixed;\n    width: 100%;\n    ', '\n    top: 0px;\n    z-index: 10;\n'], ['\n    position: fixed;\n    width: 100%;\n    ', '\n    top: 0px;\n    z-index: 10;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    position: fixed;\n    width: 100%;\n    ', '\n    z-index: 10;\n    ', '\n'], ['\n    position: fixed;\n    width: 100%;\n    ', '\n    z-index: 10;\n    ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    position: sticky;\n    left: 0;\n    z-index: 99;\n'], ['\n    position: sticky;\n    left: 0;\n    z-index: 99;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    ', '\n    ', '\n    ', '\n'], ['\n    ', '\n    ', '\n    ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    display: flex;\n    min-height: 100%;\n'], ['\n    display: flex;\n    min-height: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _body = require('../body');

var _body2 = _interopRequireDefault(_body);

var _screen = require('../screen');

var _screen2 = _interopRequireDefault(_screen);

var _loading = require('../../atoms/loading');

var _loading2 = _interopRequireDefault(_loading);

var _propagatePropsToChildren = require('../../helpers/propagatePropsToChildren');

var _propagatePropsToChildren2 = _interopRequireDefault(_propagatePropsToChildren);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bannerSizes = {
    mobile: 60,
    tablet: 40,
    desktop: 40
};

var appBarSizes = {
    mobile: 60,
    tablet: 80,
    desktop: 80
};

var footerSizes = {
    mobile: 80,
    tablet: 60,
    desktop: 60
};

var LayoutComponent = _styledComponents2.default.div(_templateObject, function (_ref) {
    var fullScreen = _ref.fullScreen;
    return fullScreen && 'min-height: 100vh;';
});

var FixedBanner = _styledComponents2.default.div(_templateObject2, function (_ref2) {
    var size = _ref2.size;
    return size && 'height: ' + size + 'px;';
});

var FixedAppBar = _styledComponents2.default.div(_templateObject3, function (_ref3) {
    var size = _ref3.size;
    return size && 'height: ' + size + 'px;';
}, function (_ref4) {
    var top = _ref4.top;
    return top && 'top: ' + top + 'px;';
});

var FixedSideBar = _styledComponents2.default.div(_templateObject4);

var LayoutContainer = _styledComponents2.default.div(_templateObject5, function (_ref5) {
    var reservedTop = _ref5.reservedTop;
    return reservedTop && 'margin-top: ' + reservedTop + 'px;';
}, function (_ref6) {
    var reservedSize = _ref6.reservedSize;
    return reservedSize && 'min-height: calc(100vh - ' + reservedSize + 'px);';
}, function (_ref7) {
    var isMobile = _ref7.isMobile,
        isNavBarExist = _ref7.isNavBarExist;
    return isMobile && isNavBarExist ? 'padding-bottom: 60px;' : null;
});

var LayoutContent = _styledComponents2.default.div(_templateObject6);

var Layout = function (_Component) {
    _inherits(Layout, _Component);

    function Layout(props) {
        _classCallCheck(this, Layout);

        var _this = _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, props));

        _this.handleScreenChange = function (screen) {
            _this.setState({ screen: screen });
        };

        _this.state = {
            screen: {}
        };
        return _this;
    }

    _createClass(Layout, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return { sideContent: typeof this.props.sideContent !== 'undefined' };
        }
    }, {
        key: 'render',
        value: function render() {
            var banner = this.props.banner;
            var showBanner = banner && this.props.context && this.props.context.storefront && this.props.context.storefront.displayCallAgent === 'True';
            var showAppBar = this.props.appbar && _react2.default.isValidElement(this.props.appbar);
            var isMobile = this.state.screen.isMobile;

            var bannerSize = 0;
            var appBarSize = 0;
            var footerSize = void 0;

            if (isMobile) {
                footerSize = footerSizes.mobile;
            } else {
                footerSize = footerSizes.desktop;
            }

            if (showBanner) {
                bannerSize = isMobile ? bannerSizes.mobile : bannerSizes.desktop;
            }

            if (showAppBar) {
                appBarSize = isMobile ? appBarSizes.mobile : appBarSizes.desktop;
            }

            var reservedTop = bannerSize + appBarSize - 1;
            var reservedSize = reservedTop + footerSize;

            var isNavBarExist = typeof this.props.sideContent !== 'undefined';

            return _react2.default.createElement(
                _screen2.default,
                { changeEvent: this.handleScreenChange },
                _react2.default.createElement(
                    LayoutComponent,
                    { fullScreen: this.props.fullScreen },
                    showBanner && _react2.default.createElement(
                        FixedBanner,
                        { isMobile: isMobile,
                            size: bannerSize
                        },
                        banner
                    ),
                    showAppBar && _react2.default.createElement(
                        FixedAppBar,
                        { banner: banner,
                            isMobile: isMobile,
                            size: appBarSize,
                            top: bannerSize
                        },
                        this.props.appbar
                    ),
                    _react2.default.createElement(
                        LayoutContainer,
                        {
                            banner: banner,
                            isMobile: isMobile,
                            isNavBarExist: isNavBarExist,
                            reservedTop: reservedTop,
                            reservedSize: reservedSize
                        },
                        _react2.default.createElement(_loading2.default, { inline: true,
                            banner: banner,
                            visible: this.props.loading,
                            pageLoadingDisplayText: this.props.pageLoadingDisplayText,
                            pageLoadingDisplayTextThresholdInSeconds: this.props.pageLoadingDisplayTextThresholdInSeconds
                        }),
                        _react2.default.createElement(
                            LayoutContent,
                            { banner: banner },
                            this.props.sideContent && _react2.default.createElement(
                                FixedSideBar,
                                { size: appBarSize,
                                    top: bannerSize
                                },
                                this.props.sideContent
                            ),
                            _react2.default.createElement(
                                _body2.default,
                                { fullWidth: this.props.fullWidth,
                                    width: this.props.width,
                                    noWidth: this.props.noWidth
                                },
                                (0, _propagatePropsToChildren2.default)(this.props.children, this.state.screen)
                            )
                        )
                    ),
                    this.props.footer
                )
            );
        }
    }]);

    return Layout;
}(_react.Component);

Layout.childContextTypes = {
    sideContent: _propTypes2.default.bool
};

exports.default = Layout;